import store from "@frameworks/web/redux/store";
import { TICKETS_DATA, TICKETS_ERROR, TICKETS_HIDE_ERROR, TICKETS_START_LOADER, TICKETS_STOP_LOADER, } from "../interface/TicketsData";
class TicketsDataActions {
    constructor() {
        this.dispatch = store.dispatch;
    }
    getTicketsData(data) {
        this.dispatch({
            type: TICKETS_DATA,
            payload: { data },
        });
    }
    setError(payload, errorType) {
        this.dispatch({
            type: TICKETS_ERROR,
            payload: { errorData: payload },
        });
    }
    hideError(errorType) {
        this.dispatch({
            type: TICKETS_HIDE_ERROR,
        });
    }
    startLoader() {
        this.dispatch({
            type: TICKETS_START_LOADER,
        });
    }
    stopLoader() {
        this.dispatch({
            type: TICKETS_STOP_LOADER,
        });
    }
}
export default TicketsDataActions;
